"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { _getGeoDataSource, _getGeoDataSourceIds } from "./queries";
const getGeoDataSource = (..._0) => __async(void 0, [..._0], function* (params = {}, fetchAll = true, callback) {
  const { filters = [], locale, isIndex = false, offset = 0, first = 50 } = params;
  const fields = fetchAll ? [
    "resourceUrl",
    "resourceId",
    "resourceType",
    "resourceStatus",
    "participatorySpaceId",
    "participatorySpaceType",
    "componentId",
    "startDate",
    "endDate",
    "title",
    "shortDescription",
    "descriptionHtml",
    "imageUrl",
    "latitude",
    "longitude",
    "geoScopeId",
    "lonlat",
    "extendedData"
  ] : ["resourceType"];
  const searchParams = new URLSearchParams({
    locale,
    offset,
    first
  });
  if (isIndex) {
    searchParams.append("is_index", "true");
  }
  filters.forEach((f) => {
    searchParams.append("filters[]", JSON.stringify(f));
  });
  fields.forEach((f) => searchParams.append("fields[]", f));
  let page;
  try {
    const response = yield fetch("/api/decidim-geo/points?" + searchParams.toString());
    if (response.ok) page = yield response.json();
    else throw new Error(yield response.text());
  } catch (error) {
    console.error(error);
    throw error;
  }
  if (!page) return { nodes: [], edges: [] };
  const { has_more: hasMoreThanOne } = (page == null ? void 0 : page.meta) || {};
  callback(page.data, hasMoreThanOne, (page == null ? void 0 : page.meta) || {});
  if (!hasMoreThanOne) return;
  let nextOffset = 50;
  searchParams.set("offset", nextOffset);
  while (true) {
    try {
      const response = yield fetch("/api/decidim-geo/points?" + searchParams.toString());
      if (response.ok) page = yield response.json();
      else throw new Error(yield response.text());
    } catch (error) {
      console.error(error);
      return;
    }
    const { has_more: hasMore } = page.meta || {};
    callback(page.data, hasMore, (page == null ? void 0 : page.meta) || {});
    if (!hasMore) break;
    nextOffset += 50;
    searchParams.set("offset", nextOffset);
  }
});
export default getGeoDataSource;
